import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contentBox d-flex flex-column justify-content-between align-items-center" }
const _hoisted_2 = { class: "d-flex flex-column justify-content-start align-items-center gap-6" }
const _hoisted_3 = { class: "choiceDescription" }
const _hoisted_4 = { class: "main d-flex flex-column justify-content-center align-items-center" }
const _hoisted_5 = { class: "footer d-flex flex-row justify-content-center align-items-center" }

import SocialMediaButtons from "@/components/Common/SocialMediaButtons.vue";
import SubscriptionsHolder from "@/components/RegistrationPage/PcVersion/SubscriptionsHolder.vue";
import SelectedBonuses from "@/components/RegistrationPage/PcVersion/SelectedBonuses.vue";

import { defineComponent } from 'vue'

const __default__ = defineComponent({
    name: 'RegistrationPagePcVersionContentHolder',
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "choiceLabel" }, "Выбери свой пропуск!", -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createTextVNode("Почитать, что такое пропуск и ЗБТ, можно на ")),
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("главной странице")
            ])),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createTextVNode("."))
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "choiceDescription" }, "Каждый следующий уровень пропуска содержит все бонусы от предыдущего.", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "choiceDescription" }, "Уже купил пропуск, но хочешь его проапгрейдить? Введи e-mail, на который зарегистрировался ранее, и следуй инструкции!", -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SubscriptionsHolder),
        _createVNode(SelectedBonuses)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(SocialMediaButtons),
      _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"contacts\" data-v-46ea1cad><div class=\"line\" data-v-46ea1cad><i class=\"bi bi-envelope-at\" data-v-46ea1cad></i><span data-v-46ea1cad>admin@scouts.su</span></div><div class=\"line\" data-v-46ea1cad><i class=\"bi bi-person-vcard\" data-v-46ea1cad></i><span data-v-46ea1cad>ИНН 772014130906</span></div></div>", 1))
    ])
  ]))
}
}

})